import { API_BASE } from "../Config";
import TicketOptionData from "../models/TicketOptionData";
import BookingEnquiryData from "../models/BookingEnquiryData";
import axiosInstance from "./BaseService";

// Get ticket options for a schedule
export const fetchTicketOptions = async (scheduleId: string): Promise<TicketOptionData[]> => {
  const response = await axiosInstance.get(`/tickets/schedule/${scheduleId}`);
  return response.data;
};

// Create/Update ticket options for a schedule (Admin only)
export const saveTicketOptions = async (scheduleId: string, ticketOptions: Omit<TicketOptionData, '_id' | 'scheduleId'>[]): Promise<TicketOptionData[]> => {
  const response = await axiosInstance.post(`/tickets/schedule/${scheduleId}`, { ticketOptions });
  return response.data;
};

// Create booking enquiry
export const createBookingEnquiry = async (bookingData: Omit<BookingEnquiryData, '_id' | 'totalAmount' | 'status' | 'createdAt' | 'updatedAt'>): Promise<BookingEnquiryData> => {
  const response = await axiosInstance.post('/tickets/booking-enquiry', bookingData);
  return response.data;
};

// Get all booking enquiries (Admin only)
export const fetchBookingEnquiries = async (page: number = 1, limit: number = 20) => {
  const response = await axiosInstance.get(`/tickets/booking-enquiries?page=${page}&limit=${limit}`);
  return response.data;
};

// Update booking enquiry status (Admin only)
export const updateBookingEnquiryStatus = async (enquiryId: string, status: 'pending' | 'confirmed' | 'cancelled'): Promise<BookingEnquiryData> => {
  const response = await axiosInstance.patch(`/tickets/booking-enquiry/${enquiryId}/status`, { status });
  return response.data;
};